import React from 'react';
import '../../App.css';
import ErrorIcon from '@material-ui/icons/Error';

export default function Error() {
    return (<div className="App">
                <ErrorIcon color="error" fontSize="large" />
        <p> You have not been authenticated to use SupplyCAT, please use MyMRO to access SupplyCAT</p>
    </div>)
}